import { isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';
import { DEFAULT_LANG, isSupportedLang, type SupportedLang } from '../../constants/languages';

/**
 * The app is shown in Spanish to everyone: no language switcher and no browser detection (decided
 * 01-nov-2026). The other translation files stay so a language can be turned on later from here.
 */
@Injectable({
	providedIn: 'root',
})
export class LanguageDetectionService {
	private transloco = inject(TranslocoService);
	private platformId = inject(PLATFORM_ID);

	/** Language of the app: the branding language when it is a supported one, otherwise DEFAULT_LANG. */
	resolveLanguage(brandingLang?: string): SupportedLang {
		return isSupportedLang(brandingLang) ? brandingLang : DEFAULT_LANG;
	}

	/** Activates the app language and waits for its translations (browser only). */
	async detectAndSetLanguage(brandingLang?: string): Promise<void> {
		const lang = this.resolveLanguage(brandingLang);
		this.transloco.setActiveLang(lang);

		if (isPlatformBrowser(this.platformId)) {
			await firstValueFrom(this.transloco.load(lang)).catch(() => undefined);
		}
	}

	getCurrentLanguage(): string {
		return this.transloco.getActiveLang();
	}
}
